import React from 'react';
import { Dialog, Button, Stack, Typography } from '@krakentech/coral';
import { IconGift } from '@krakentech/icons';

import { useRewardJourney } from '@/hooks/utils/useRewardJourney';
import { RewardJourneyType } from '@/types/rewards';

type RewardDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  journey: RewardJourneyType;
};

export const RewardDialog = ({
  isOpen,
  onClose,
  journey,
}: RewardDialogProps) => {
  const { redirectToRewards } = useRewardJourney();

  const handleNoThanks = () => {
    onClose();
  };

  const handleClaimReward = () => {
    onClose();
    redirectToRewards(journey);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      ariaLabelledBy="reward-dialog"
      maxWidth="sm"
    >
      <Stack direction="vertical" gap="smMd">
        <Stack direction="vertical" gap="xsSm" alignItems="center">
          <IconGift size={60} />
          <Stack direction="vertical" gap="xxs">
            <Typography textAlign="center" variant="h2">
              You&apos;ve earned a reward!
            </Typography>
            <Typography textAlign="center">
              You&apos;ve unlocked a reward - want to find out what it is?
            </Typography>
          </Stack>
        </Stack>
        <Stack
          gap="sm"
          direction="vertical"
          md={{ direction: 'horizontal-reverse' }}
        >
          <Button onClick={handleClaimReward} fullWidth>
            Claim reward
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleNoThanks}
            fullWidth
          >
            No thanks
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default RewardDialog;
